'use client';

import { Datastore } from '@youversion/analytics-types';
import { AppRouterAnalytics, updateCurrentContext } from '@youversion/analytics-youversion-nextjs';
import { useEffect, useRef, useState } from 'react';

import { useAppLanguage } from '@/context/appLanguage';
import { useCurrentOrganizationId } from '@/context/organization/useCurrentOrganizationId';
import { APP_ENV, COMMIT_SHA, DATAMAN_URL, YV_AUTH_CLIENT_ID } from '@/utils/env';

export default function Analytics() {
  const { organizationId } = useCurrentOrganizationId();
  const { appLanguage } = useAppLanguage();

  // Ref so the provider closure always reads the current org ID,
  // not the stale value captured in useState's lazy initializer.
  const organizationIdRef = useRef(organizationId);
  organizationIdRef.current = organizationId;

  const [config] = useState<Datastore.Config>(() => ({
    applicationId: 'com.youversion.connect',
    appVersion: COMMIT_SHA,
    baseDomain: 'youversion.com',
    clientId: YV_AUTH_CLIENT_ID,
    endpoint: DATAMAN_URL as Datastore.Config['endpoint'],
    environment: APP_ENV,
    localeFallback: appLanguage ?? 'en-US',
    providers: {
      organizationIdProvider: async () => organizationIdRef.current || null,
    },
  }));

  useEffect(() => {
    if (!organizationId?.length) {
      return;
    }

    updateCurrentContext({ organization_id: organizationId });

    return () => {
      updateCurrentContext({ organization_id: null });
    };
  }, [organizationId]);

  return <AppRouterAnalytics config={config} />;
}
